import { getBusinessAuthority } from '@/apis/auth-repository';
import {
	getBusinessUserInfo as apiGetBusinessUserInfo,
	getMainTournamentList,
	refreshGeneralUserInfo as apiRefreshGeneralUserInfo,
} from '@/apis/content';
import { getCurrentOwnerData, putGetUserInfoRO, putSigninUser } from '@/model/dexie/ownerDexie';

export const refreshGeneralUserInfo = async () => {
	try {
		const userInfo = await apiRefreshGeneralUserInfo();
		await putGetUserInfoRO(userInfo);
		return { data: { data: userInfo } };
	} catch (error) {
		console.error('Failed to refresh user info:', error);
		throw error;
	}
};

export const getBusinessUserInfo = async ({ businessAccountId }: { businessAccountId: string }) => {
	try {
		const userInfo = await apiGetBusinessUserInfo({ businessAccountId });

		const authority = await getBusinessAuthority(businessAccountId);

		if (userInfo && authority && authority.data) {
			const userData = { ...userInfo.data.userInfo.user, authority: authority.data.authority };
			await putSigninUser(userData as any);
			return userData;
		}
	} catch (error) {
		console.error('Failed to get business user info:', error);
		throw error;
	}
};

/** TODO: Current ID 얻도록 수정해야함 */
export const currentInfoUpdate = async () => {
	const owner = await getCurrentOwnerData();
	if (owner && (owner.authority ?? 'USER') === 'USER') {
		refreshGeneralUserInfo();
	} else if (owner) {
		getBusinessUserInfo({ businessAccountId: owner.id });
	}
};

// Re-export from APIs
export { getMainTournamentList };
